import type {
  PullRequestCommentKind,
  PullRequestEditCapabilities,
  PullRequestReviewVerdict,
} from "@cmmd-forge/contracts";

export function canEditPullRequest(capabilities: PullRequestEditCapabilities | undefined): boolean {
  return capabilities?.changeRequest === true;
}

export function availableReviewVerdicts(input: {
  readonly hostVerdicts: ReadonlyArray<PullRequestReviewVerdict>;
  readonly viewerVerdicts: ReadonlyArray<PullRequestReviewVerdict>;
}): ReadonlyArray<PullRequestReviewVerdict> {
  const viewerVerdicts = new Set(input.viewerVerdicts);
  return input.hostVerdicts.filter((verdict) => viewerVerdicts.has(verdict));
}

export function canEditPullRequestComment(input: {
  readonly canEditComments: boolean;
  readonly viewer: string | undefined;
  readonly author: string | undefined;
  readonly kind: PullRequestCommentKind;
}): boolean {
  return (
    input.canEditComments &&
    input.viewer !== undefined &&
    input.viewer?.toLocaleLowerCase() === input.author?.toLocaleLowerCase() &&
    input.kind !== "review"
  );
}
